import 'jquery-dateformat/dist/jquery-dateformat.js'
import {format, isSameMonth, isBefore, isAfter, isPast, isToday, isSameDay} from 'date-fns';
import {nl, de, enUS as en} from 'date-fns/locale';

jQuery(document).ready(function ($) {
  const today = new Date();
  let {lang} = window.pll;
  if (!lang) lang = 'nl';
  
  const distinctDates = Array.from(Object.values(window.dates.distinct));

  const onChangeMonthYear = (year, month) => {
    const selectedDate = new Date(year, month - 1);
    clearAll();
    const events = window.events.filter(event => {
      if (event.end_date) {
        return isSameMonth(selectedDate, getEventDateAsDateObject(event.date)) || isSameMonth(selectedDate, getEventDateAsDateObject(event.end_date));
      }

      return isSameMonth(selectedDate, getEventDateAsDateObject(event.date));
    });
    setDateTitle(`01/${month}/${year}`);

    if (events.length === 0) {
      populateTemplate({
        post_title: window.translations['no-events'],
        date: '',
        end_date: false,
        has_link: false,
      }, false);
    } else {
      events.forEach(event => populateTemplate(event, true));
    }
  }

  const beforeShowDay = (date) => {
    const ymd = formatDate(date);

    if (distinctDates.includes(ymd)) {
      const eventsForDate = window.events.filter(event => {
        if (event.end_date) {
          return (isBefore(date, getEventDateAsDateObject(event.end_date)) &&
            !isAfter(getEventDateAsDateObject(event.date), date)) || isSameDay(date, getEventDateAsDateObject(event.end_date));
        }

        return event.date === ymd;
      });

      const classes = eventsForDate.map(event => `event--${event.type}`);
      eventsForDate.map(event => {
        if (event.type !== 'holiday') {
          return;
        }

        if (event.date === ymd) {
          classes.push('holiday--first-day');
        }
        if (event.end_date === ymd) {
          classes.push('holiday--last-day');
        }
      });
      classes.push('available');

      return [true, classes.join(' ')];
    }

    if (isPast(date) && !isToday(date)) {
      return [false, 'disabled ui-datepicker--past']
    }

    return [false, 'disabled'];
  }

  $.datepicker.regional['nl'] = {
    closeText: 'Sluiten',
    currentText: 'Vandaag',
    monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
      'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
      'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
    dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    weekHeader: 'Wk',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: '',
  };

  $.datepicker.regional['de'] = {
    closeText: 'Schließen',
    currentText: 'Heute',
    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
      'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    weekHeader: 'KW',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: '',
  };

  $.datepicker.setDefaults($.datepicker.regional[lang]);

  $('#datepicker').datepicker({
    minDate: new Date(today.getFullYear(), today.getMonth(), +1),
    maxDate: '+1Y',
    altField: '#dateHidden',
    dateFormat: 'dd/mm/yy',
    prevText: '<span class="btn btn--small btn--primary"><i class="far fa-arrow-left"></i></span>',
    nextText: '<span class="btn btn--small btn--primary"><i class="far fa-arrow-right"></i></span>',
    beforeShowDay,
    onChangeMonthYear,
  }).datepicker('setDate', `01/${today.getMonth() + 1}/${today.getFullYear()}`);

  // Initial date input.
  clearAll();
  const events = window.events.filter(event => isSameMonth(today, getEventDateAsDateObject(event.date)));
  setDateTitle(`01/${today.getMonth() + 1}/${today.getFullYear()}`);
  if (events.length === 0) {
    populateTemplate({
      post_title: window.translations['no-events'],
      date: '',
      end_date: false,
      has_link: false,
    }, false);
  } else {
    events.forEach(event => populateTemplate(event, true));
  }
});

const clearAll = () => {
  const target = document.querySelector('.events-calendar__items');

  if (!target) return;

  target.innerHTML = '';
}
/* eslint-disable */
const populateTemplate = ({post_title, date, end_date, has_link, link_label, link_url}, as_card = true) => {
  if (!('content' in document.createElement('template'))) {
    return;
  }
  let template;

  if (as_card) {
    template = document.querySelector('template#events-calendar__item--template');
  } else {
    template = document.querySelector('template#events-calendar__item--no-activities');
  }

  const locale = get_locale();
  if (!template) {
    return;
  }

  const target = document.querySelector('.events-calendar__items');
  const clone = template.content.cloneNode(true);
  clone.querySelector('.event__title').innerHTML = post_title;
  if (date && as_card) {
    if (end_date) {
      clone.querySelector('.event__time').innerHTML = `
    ${format(getEventDateAsDateObject(date), 'EEEE dd MMMM', {locale})} t/m ${format(getEventDateAsDateObject(end_date), 'EEEE dd MMMM', {locale})} `;
    } else {
      clone.querySelector('.event__time').innerHTML = format(getEventDateAsDateObject(date), 'EEEE dd MMMM', {locale});
    }
  }

  if (has_link && as_card) {
    const linkTemplate = document.querySelector('template#events-calendar__item__button--template');
    const linkClone = linkTemplate.content.cloneNode(true);

    if (link_url && link_label) {
      const link = linkClone.querySelector('a')
      link.setAttribute('href', link_url);
      link.innerHTML = link_label;

      clone.querySelector('.event__button-wrapper').appendChild(linkClone);
    }
  }

  target.appendChild(clone);
}

const formatDate = date => `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;

const getEventDateAsDateObject = date => {
  let _badDateFormat = date.split('/');
  _badDateFormat = [_badDateFormat[1], _badDateFormat[0], _badDateFormat[2]].join('/');

  return new Date(_badDateFormat);
}

const setDateTitle = date => {
  const target = document.querySelector('.events-calendar__items');

  if (!target) return;

  const locale = get_locale();
  target.innerHTML = `<h2>${format(getEventDateAsDateObject(date), 'MMMM yyyy', {locale})}</h2>`;
}


function get_locale() {

  let locale;
  switch (window.lang) {
    case 'de':
      locale = de;
      break;
    case 'en':
      locale = en;
      break;
    case 'nl':
    default:
      locale = nl;
      break;
  }

  return locale;
}



// WEBPACK FOOTER //
// ./scripts/events-calendar.js